import { z } from 'zod';
/**
 * `sync_jobs` row. Spec §5.4 — surfaces webhook-driven sync history to the
 * admin UI webhook health panel. Status set mirrors the worker's terminal
 * states (`marketplace-api/src/workers/sync-repo.ts`).
 */
export const syncJobStatusSchema = z.enum([
    'pending',
    'running',
    'succeeded',
    'failed',
    'validation_failed',
]);
/**
 * Admin-view list-row shape for `GET /api/sources/:id/sync-jobs`. Powers the
 * webhook health panel — the admin operator inspects recent deliveries to
 * confirm rotations and diagnose failures. `validationSkipped` reflects the
 * `manifest.validation` feature-flag state at job runtime.
 */
export const syncJobAdminSchema = z.object({
    id: z.string().uuid(),
    sourceId: z.string().uuid(),
    headSha: z.string().min(1),
    status: syncJobStatusSchema,
    startedAt: z.string().datetime().nullable(),
    finishedAt: z.string().datetime().nullable(),
    error: z.string().nullable(),
    validationSkipped: z.boolean(),
});
//# sourceMappingURL=sync-job.js.map